module.exports = __webpack_public_path__ + "static/img/11_健康顧問.f861fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/11_健康顧問.png
// module id = Hl/O
// module chunks = 1